import PropTypes from "prop-types";
import React from "react";
import {
  Box,
  Button,
  Typography,
  FormControlLabel,
  FormGroup,
  Checkbox,
  FormControl
} from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { useDispatch, useSelector } from "react-redux";
import { updateCalendarHiddenCalendars } from "../../../redux/actions/calendarActions";

const useStyles = makeStyles(theme => ({
  listHeader: {
    textTransform: "capitalize"
  }
}));

const CalendarList = ({ listName, buttonText, onButtonClick, calendars }) => {
  const classes = useStyles();
  return (
    <Box display="flex" flexDirection="column" mt={4} width="100%">
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={1.5}
      >
        <Typography
          variant="h6"
          color="textSecondary"
          className={classes.listHeader}
        >
          {listName}
        </Typography>
        {onButtonClick && (
          <Button color="primary" onClick={onButtonClick} size="small">
            {buttonText}
          </Button>
        )}
      </Box>
      <CalendarCheckboxList calendars={calendars} />
    </Box>
  );
};
const CalendarCheckbox = ({ name, color, checked, onChange }) => {
  return (
    <FormControlLabel
      control={
        <Checkbox
          style={{ color }}
          checked={checked}
          onChange={onChange({ name })}
          value={name}
        />
      }
      label={name}
    />
  );
};
const CalendarCheckboxList = ({ calendars }) => {
  const hiddenCalendars = useSelector(
    state => state.calendarState.hiddenCalendars
  );
  const dispatch = useDispatch();

  const handleCheckedCalendarsChange = calendar => event => {
    const newEventNames = hiddenCalendars.filter(
      name => name !== calendar.name
    );
    if (!event.target.checked) {
      newEventNames.push(calendar.name);
    }
    dispatch(updateCalendarHiddenCalendars(newEventNames));
  };

  return calendars ? (
    <FormControl component="fieldset">
      <FormGroup>
        {calendars.map((calendar, index) => (
          <CalendarCheckbox
            key={calendar.name + index}
            onChange={handleCheckedCalendarsChange}
            name={calendar.name}
            selected={calendar.selected}
            color={calendar.color}
            checked={!hiddenCalendars.includes(calendar.name)}
          />
        ))}
      </FormGroup>
    </FormControl>
  ) : null;
};

/**
 * Used in the calendar control panel to filter, import, and export calendars
 */
const CalendarSelector = ({
  userPermissions,
  calendarLists,
  onImportModalOpenChange,
  onExportModalOpenChange
}) => {
  const trainingCalendars = calendarLists.training.calendars;
  const otherCalendars = calendarLists.other.calendars;
  const exportButtonText =
    trainingCalendars.length > 1 ? "Export Calendars" : "Export Calendar";
  return (
    <Box display="flex" flexDirection="column" alignItems="flex-start">
      <CalendarList
        onButtonClick={() => onExportModalOpenChange(true)}
        listName="Training Calendars"
        buttonText={exportButtonText}
        calendars={trainingCalendars}
      />
      {!(userPermissions.silver || userPermissions.validate) && (
        <CalendarList
          // onButtonClick={() => onImportModalOpenChange(true)}
          listName="Other Calendars"
          buttonText="Import Calendars"
          calendars={otherCalendars}
        />
      )}
    </Box>
  );
};

export default CalendarSelector;

CalendarSelector.propTypes = {
  calendar: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      color: PropTypes.string
    })
  )
};
